import axios from "axios";

// Prefer same-origin `/api` when the app is served from its own domain (production),
// otherwise fall back to the explicit REACT_APP_BACKEND_URL (useful in the preview
// environment where the backend lives on a different host). This means a frontend
// built for the preview URL still works correctly when served from a custom domain
// such as https://soiree-invites.com — because the browser will hit the same
// origin and cookies flow as a first-party request.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function chooseBase() {
  if (typeof window === "undefined") return `${BACKEND_URL}/api`;
  try {
    const here = window.location.origin;
    if (BACKEND_URL && new URL(BACKEND_URL).origin !== here) {
      // If the deployment URL differs from the current origin (common when a custom
      // domain is added after the build), call the backend on *this* origin.
      return `${here}/api`;
    }
  } catch { /* ignore */ }
  return `${BACKEND_URL}/api`;
}

export const API = chooseBase();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
